import React from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";
import { BusinessReportOutcomeShareModalForm } from "./form";
import { BusinessReportOutcomeShareModalUsers } from "../shareModal/users";
import { BusinessReportOutcomeShareModalAccess } from "@/modules/snapshots/modals/shareModal/generalAccess";
import { useSnapshotPermission } from "@/modules/snapshots/hooks/useSnapshotPermission";

interface Props {
  businessReportOutcome: BusinessReportOutcomeDetails;
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
}

export const BusinessReportOutcomeShareModal: React.FC<Props> = ({ isOpen, setIsOpen, businessReportOutcome }) => {
  const [isNewUserSelected, setIsNewUserSelected] = React.useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const isReadOnly = !useSnapshotPermission(businessReportOutcome);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="flex w-full max-w-[40vw] flex-grow flex-col">
        <DialogHeader>
          <DialogTitle>Share Snapshot &#34;{businessReportOutcome.business_report.name}&#34;</DialogTitle>
        </DialogHeader>
        <BusinessReportOutcomeShareModalForm
          isReadOnly={isReadOnly}
          businessReportOutcome={businessReportOutcome}
          isNewUserSelected={isNewUserSelected}
          setIsNewUserSelected={setIsNewUserSelected}
        />

        {!isNewUserSelected && (
          <>
            <BusinessReportOutcomeShareModalUsers
              permissions={businessReportOutcome.permissions}
              isReadOnly={isReadOnly}
            />
            {!!businessReportOutcome.permissions && (
              <BusinessReportOutcomeShareModalAccess
                isReadOnly={isReadOnly}
                businessReportOutcomeId={businessReportOutcome.id}
                access={businessReportOutcome.access}
              />
            )}
            <DialogFooter>
              <Button onClick={handleClose} variant="default">
                Close
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
